import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import type {ExplorerHeroProps, ExplorerHeroStatProps} from "./types";
import './explorer-hero.scss';

export function ExplorerHero({
    className,
    backgroundImage,
    eyebrow,
    title,
    intro,
    backLabel,
    onBack,
    statsLabel,
    children
}: ExplorerHeroProps) {
    return (
        <header
            className={`explorer-hero ${className ?? ''}`.trim()}
            style={backgroundImage ? ({'--explorer-hero-image': `url("${backgroundImage}")`} as React.CSSProperties) : undefined}
        >
            <div className="explorer-hero__content">
                {backLabel && onBack ?
                    <button type="button" className="explorer-hero__back" onClick={onBack}>
                        <FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" />
                        {backLabel}
                    </button>
                    : null
                }
                <p className="explorer-hero__eyebrow">{eyebrow}</p>
                <h1 className="explorer-hero__title">{title}</h1>
                <p className="explorer-hero__intro">{intro}</p>
                {children}
            </div>
        </header>
    );
}

export function ExplorerHeroStats({children, ariaLabel}: {children: React.ReactNode, ariaLabel?: string}) {
    return (
        <div className="explorer-hero__stats" aria-label={ariaLabel ?? "Explorer summary"}>
            {children}
        </div>
    );
}

export function ExplorerHeroStat({icon, label, value, helper}: ExplorerHeroStatProps) {
    return (
        <div className="explorer-hero__stat">
            <span className="explorer-hero__stat-icon" aria-hidden="true">
                {icon}
            </span>
            <span className="explorer-hero__stat-copy">
                <strong>{value}</strong>
                <span>{label}</span>
                {helper ? <small>{helper}</small> : null}
            </span>
        </div>
    );
}
